import { render, staticRenderFns } from "./ScoredActivities.vue?vue&type=template&id=6fe9706f&scoped=true"
import script from "./ScoredActivities.vue?vue&type=script&lang=js"
export * from "./ScoredActivities.vue?vue&type=script&lang=js"
import style0 from "./ScoredActivities.vue?vue&type=style&index=0&id=6fe9706f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe9706f",
  null
  
)

export default component.exports